import React, {Component} from 'react';
import Wallpaper from '../common/ef-wallper';
import {connect} from "react-redux";
import {mapDispatchToProps, mapStateToProps} from "../common/redux-dispatch-to-props";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import PageContentWallpaper from "../common/ef-pageContent";
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from "../../config";
import TableDataView from "../tables/TableDataView";

const serverAPI = "https://chela.easipath.com/backend-chela/api";
const sortData = (sortKey, data) => {
    const keyOne = sortKey;
    if(data ===null){
        return [];
    }
    data.sort((a, b) => (a[keyOne] > b[keyOne]) ? 1 : -1)
    return data;
}

class ConReconHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            isLoading: false,
            showEdit:false
        }
    }

    componentDidMount = async () => {
        await this.fetchHistory();
    }
    fetchHistory = async () => {
        let _this = this;
        let conds = [];
        await this.fetchingAll("ReportFile", conds, (data) => {
            console.log("ReportFile :> ", data);
            _this.setState({
                Data: data,
            });
        });
    }

    fetchReport=async ()=>{
        let _this = this;
        this.setState({isLoading:true});
        let table = "ReportFile"
        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: [],
        }
        const url = serverAPI + "/recon/report";
        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((response) => {
                if (typeof response.RESULT !== "undefined") {
                    let tmp = _this.state;
                    tmp.Data = response.RESULT;
                    tmp.isLoading = false;
                    _this.setState(tmp);
                    //TODO reinitialize state

                }
            }).catch((e) => {

        });
    }

    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }

    renderListUtil = () => {
        if (this.state.showEdit) {
            return null
        }
        let columns = [
            {id: 'name', label: 'Field', minWidth: 170, dataType: "string"},
            {id: 'startdate', label: 'Start Date', minWidth: 170, dataType: "string"},
            {id: 'enddate', label: 'End Date.', minWidth: 170, dataType: "string"},
            {id: 'total', label: 'Total Record', minWidth: 170, dataType: "string"},
            {id: 'totalcost', label: 'Cost', minWidth: 170, dataType: "string"},
        ];
        let ls=[];
        const attrs = this.state.Data;
        for(let i in attrs){
            const row=attrs[i];
            console.log("renderList compare > ",row.module," == ",this.props.module,"> ",(row.module ===this.props.module))
            if(row.module ===this.props.module){
                ls.push(row)
            }
        }
        ls =sortData("targetdate",ls);
        let data = {columns: columns, data: ls};
        return (
            <TableDataView
                {...data}
                tableTitle={"People Role Attribute"}
                onAddRecord={this.onAddRecord}
                onDelete={this.onDelete}
            />
        )
    }


    render() {

        return (
            <Wallpaper {...this.props} hasHeader={true} hasFooter={true}>

                <PageContentWallpaper {...this.props} >
                    <MuiThemeProvider>
                        <h1>History Recon downloaded file from Telkom FTP</h1>

                        {this.renderListUtil()}

                    </MuiThemeProvider>
                </PageContentWallpaper>

            </Wallpaper>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ConReconHistory)
